/* eslint-disable @typescript-eslint/no-explicit-any */
import { OptionsType } from "react-select";
import { CartProduct } from "@pepdirect/shared/types";

export const getQuantityOptions = (
  product: Partial<CartProduct>,
  maxCartQty: number
): OptionsType<any> => {
  const total = product.inventoryQty
    ? Math.min(product.inventoryQty, maxCartQty)
    : maxCartQty;

  const options = range(0, total).map((num) => {
    return {
      value: num.toString(),
      label: num.toString(),
    };
  });

  return options;
};

/**
 * Helper function to return an array of numbers from start to end.
 * e.g., range(1, 4) gets [1, 2, 3, 4]
 * @param start
 * @param end
 */
export function range(start: number, end: number): number[] {
  return [...Array(end - start + 1)].map((_i, idx) => idx + start);
}
